import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "antd/es/input/Input";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import { setLoader } from "../../../Slices/loaderSlice";
import "./employees.css";
import { setId } from "../../../Slices/employeeslice";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { S3ACCESSURL } from "../../../databucket";
const AllEmployee = () => {
  const [id] = useState();
  const dispatch = useDispatch();
  const navigation=useNavigate();
  const details = useSelector((state) => state.employee.AllEmployees);
  const [filteredEmployees, setFilteredEmployees] = useState();
  const [statusFilter, setStatusFilter] = useState('Active');
  useEffect(() => {
    dispatch(setId(true))
    dispatch(setLoader(details.length > 0 ? false : true));
    const filtered = details.filter(emp => emp.employeestatus !== "InActive");
    setFilteredEmployees(filtered);
  }, [details, dispatch]);
 
  const employeeData = filteredEmployees?.map((employee) => ({
    id: employee?.EmpID,
    _id: employee?.id,
    firstname: employee?.firstname,
    lastname: employee?.lastname,
    designation: employee?.designation,
    department: employee?.department,
    image: employee?.image,
    employeestatus: employee?.employeestatus
  })) || [];
  function getInitials(name) {
    if (!name) return 'N/A';
    const names = name.split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    const firstInitial = names[0].charAt(0).toUpperCase();
    const secondInitial = names[1] ? names[1].charAt(0).toUpperCase() : '';
    return firstInitial + secondInitial;
  }
 
  const handleChange = (e) => {
    const val = e.target.value;
    let filtered = details;
    if (val) {
      filtered = filtered.filter((item) =>
        item.firstname?.toLowerCase()?.includes(val?.toLowerCase()) ||
        item.lastname?.toLowerCase()?.includes(val?.toLowerCase())
      );
    }
    if (statusFilter !== "All") {
      filtered = filtered.filter(emp =>
        statusFilter === "Active"
          ? emp.employeestatus !== "InActive"
          : emp.employeestatus === "InActive"
      );
    }
    setFilteredEmployees(filtered);
  };
  const handleStatusChange = (value) => {
    setStatusFilter(value);
    let filtered = details;
    const searchInput = document.querySelector('.input-search')?.value || '';
    if (searchInput) {
      filtered = filtered.filter((item) =>
        item.firstname?.toLowerCase()?.includes(searchInput.toLowerCase()) ||
        item.lastname?.toLowerCase()?.includes(searchInput.toLowerCase())
      );
    }
    if (value !== "All") {
      filtered = filtered.filter(emp =>
        value === "Active"
          ? emp.employeestatus !== "InActive"
          : emp.employeestatus === "InActive"
      );
    }
    setFilteredEmployees(filtered);
  };
  const groupedByDepartment = employeeData.reduce((acc, employee) => {
    const dept = employee.department || "Other";
    if (!acc[dept]) {
      acc[dept] = [];
    }
    acc[dept].push(employee);
    return acc;
  }, {});
 
 
const handleRedirect =async (id) => {
  try {
    navigation(`/employees/${id}`)
} catch (error) {
  console.error("First thunk failed:", error);
 
}
  };
  const renderEmployeeCards = (list) => (
    list.length > 0 ? (
      list.map((employee, index) => (
        <div  onClick={() => handleRedirect(employee?._id)}  className="col-md-4 col-sm-6 col-12 col-lg-3 col-xl-3 h-300px" key={employee?._id || employee?.id || index}>
          <div className="profile-widget">
            <div className="profile-img">
              {employee?.image ? (
                <>
                  <img
                    src={S3ACCESSURL+employee?.image}
                    alt="User"
                  />
                  <div
                    className="status-indicator"
                    style={{
                      backgroundColor: employee?.employeestatus !== "InActive" ? 'green' : 'red',
                    }}
                  ></div>
                </>
              ) : (
                <div className="no-image">
                  <div
                    className="status-indicator"
                    style={{
                      backgroundColor: employee?.employeestatus !== "InActive" ? 'green' : 'red',
                    }}
                  ></div>
                  {employee?.firstname ? getInitials(employee.firstname) : "N/A"}
                </div>
              )}
            </div>
            <div className="small text-muted">
              {employee?.department || "N/A"}
            </div>
            <h4 className="user-name m-t-10 mb-0 text-ellipsis">
              <div>
                {employee?.firstname
                  ? employee.firstname.length > 15
                    ? `${employee.firstname.slice(0, 15)}...`
                    : employee.firstname
                  : "N/A"}{" "}
                {employee?.lastname || "N/A"}
              </div>
            </h4>
          </div>
        </div>
      ))
    ) : (
      <p className="no-employees">No employees found</p>
    )
  );
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle="Employees"
          title="Dashboard"
          subtitle="Employee"
          modal="#add_employee"
          name="Add Employee"
          Linkname="/employees"
          Linkname1="/employees-list"
          view="grid"
        />
        <Select
          style={{ width: 170 }}
          value={statusFilter}
          onChange={handleStatusChange}
          options={[
            { value: "All", label: "All Employees" },
            { value: "Active", label: "Active Employees" },
            { value: "Inactive", label: "Inactive Employees" }
          ]}
        />
        <Input
          type="text"
          placeholder="Search By Name"
          onChange={handleChange}
          className="input-search"
        />
        <div>
          {Object.keys(groupedByDepartment).map((dept) => (
            <div style={{ width: "100%", marginTop: "10px" }} key={dept}>
              <h4 style={{ marginBottom: "20px" }}>{dept}</h4>
              <div className="row">
                {renderEmployeeCards(groupedByDepartment[dept])}
              </div>
            </div>
          ))}
        </div>
      </div>
      <AllEmployeeAddPopup id={id} />
      <DeleteModal Name="Delete Employee" />
    </div>
  );
};
 
export default AllEmployee;
 